import type { ReactNode } from "react";

export function EmptyState({ title, description, action }: { title: string; description?: string; action?: ReactNode }) {
  return (
    <div className="rounded-md border border-dashed border-cyan-300/20 bg-black/20 p-8 text-center">
      <h3 className="font-display text-xl font-semibold uppercase text-white">{title}</h3>
      {description && <p className="mx-auto mt-2 max-w-xl text-sm leading-6 text-content-secondary">{description}</p>}
      {action && <div className="mt-5 flex justify-center">{action}</div>}
    </div>
  );
}
